<div
  class="mts-client-logo-strip"
  [class.mts-client-logo-strip--wrap]="variant === 'wrap'"
  [class.mts-client-logo-strip--marquee]="variant === 'marquee'"
  [class.mts-client-logo-strip--hero]="variant === 'wrap' && wrapPreset === 'hero'"
  [class.mts-client-logo-strip--section]="variant === 'wrap' && wrapPreset === 'section'">
  <p *ngIf="title" class="mts-client-logo-strip__title">{{ title }}</p>

  <div *ngIf="variant === 'wrap'" class="mts-client-logo-strip__logos">
    <img
      *ngFor="let logo of resolvedLogos"
      [src]="logo.src"
      [alt]="logo.name"
      class="mts-client-logo-strip__img" />
  </div>

  <div *ngIf="variant === 'marquee'" class="mts-client-logo-strip__marquee-wrap">
    <div class="mts-client-logo-strip__marquee">
      <div class="mts-client-logo-strip__marquee-inner">
        <img
          *ngFor="let logo of resolvedLogos"
          [src]="logo.src"
          [alt]="logo.name"
          class="mts-client-logo-strip__img" />
      </div>
      <div class="mts-client-logo-strip__marquee-inner" aria-hidden="true">
        <img
          *ngFor="let logo of resolvedLogos"
          [src]="logo.src"
          [alt]="logo.name"
          class="mts-client-logo-strip__img" />
      </div>
    </div>
  </div>
</div>
